function Sidebar({ children }) {
  return (
    <aside
      className="sidebar overflow-y-auto scrollbar-hide bg-ukgov-blue text-white"
      style={{ width: "20rem" }}
    >
      {children}
    </aside>
  );
}

export default Sidebar;
